module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--3--create-403bd78f.jpg";